import { sendRequest } from "../axios";
export default {
  state: {
    agentFirmBankRekv: null,
  },
  mutations: {
    SET_AGENT_FIRM_BANK_REKV(state, commit) {
      state.agentFirmBankRekv = commit;
    },
  },

  actions: {
    getAgentFirmBankRekv({ commit }) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("AgentFirmBankRekvController", "get", null, reject).then(
          (response) => {
            commit("SET_AGENT_FIRM_BANK_REKV", response.data.agentFirmBankRekv);
            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
    storeAgentFirmBankRekv({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("AgentFirmBankRekvController", "post", data, reject).then(
          (response) => {
            commit("SET_AGENT_FIRM_BANK_REKV", response.data.agentFirmBankRekv);
            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
    updateAgentFirmBankRekv({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest(
          `AgentFirmBankRekvController/${data.id}`,
          "put",
          data,
          reject
        ).then((response) => {
          commit("SET_AGENT_FIRM_BANK_REKV", response.data.agentFirmBankRekv);
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    deleteAgentFirmBankRekv({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest(
          `AgentFirmBankRekvController/${data}`,
          "delete",
          reject
        ).then((response) => {
          commit("SET_AGENT_FIRM_BANK_REKV", response.data.agentFirmBankRekv);
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
  },
  getters: {
    getAgentFirmBankRekv: (state) => state.agentFirmBankRekv,
  },
};
